/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 */
import React from 'react';
import CustomModal from '../../../components/Modal/CustomModal';
import CustomChip from '../../../components/CustomChip';
import {CleanIcon, IconPersonEmail, PersonChip} from '../../../components/buttons/IconButtons';
import { colors } from '../../../enums/colors';
import { InviteAgainModalApp } from '../Functionality/InviteAgainModalApp';
import InviteExternalUserStep3 from './InviteExternalUserSteps/InviteExternalUserStep3';

/**
 * Form the logged resident fills to send the invitation of one visit again, the
 * visitor is the one of the invitation and only the period and the instructions
 * of the new visit are asked. It is opened from the invite again action of the
 * invitations table.
 *
 * @param {Object} props
 * @param {boolean} props.show - Renders the modal.
 * @param {Function} props.onHide - Closes the modal.
 * @param {Object} props.itemSelected - Visit the invitation is sent again for.
 * @param {Function} [props.setModified] - Raises the flag that reloads the invitations of the tab.
 */
const InviteAgainModal = ({ show, onHide, itemSelected, setModified }) => {
    const {
        t,
        emptyFields,
        invitation,
        visitorName,
        visitorType,
        handleChange,
        handleClose,
        handleConfirm
    } = InviteAgainModalApp({ show, onHide, itemSelected, setModified });

    return (
        <CustomModal
            show={show}
            size={'lg'}
            buttonConfirm={'confirm'}
            buttonCancelText={'cancel'}
            cancelButton={true}
            confirmButton={true}
            onConfirm={handleConfirm}
            onHide={handleClose}
            onClose={handleClose}
            topLeftHeader={
                <div className={'d-flex align-items-center'}>
                    <div><IconPersonEmail /></div>
                    <p className={'fs-modal-title font-color-general-950 ibl-font-w-600 ml-2 mb-0'}>
                        {t('invite_again')}
                    </p>
                </div>
            }
        >
            {/* Visitor the invitation is sent again to, it cannot be changed here */}
            <div className={'my-3 border-radius-8px border-full-shades-300'}>
                <div className={"p-3 d-flex align-items-center"}>
                    <div className={'d-flex align-items-center'}>
                        <div className={'d-flex icon-color-shades-700 mr-8px'}><PersonChip/></div>
                        <p className={'font-color-general-950 ibl-font-w-600 fs-14px mb-0'}>{visitorName}</p>
                    </div>

                    <div className={"d-flex justify-content-end ml-auto"}>
                        <CustomChip
                            background={colors.secondary100}
                            borderColor={colors.secondary150}
                            fontColor={colors.secondary700}
                            legend={visitorType}
                            variant={'compact'}
                            icon={CleanIcon}
                            classNameIcon={'btn-icon-svg-12px  icon-color-secondary-700'}
                        />
                    </div>

                </div>

                <div className={"border-bottom-shades-300 mb-4"}/>

                <InviteExternalUserStep3
                    t={t}
                    emptyFields={emptyFields}
                    invitation={invitation}
                    handleChange={handleChange}
                />
            </div>


        </CustomModal>
    );
};

export default InviteAgainModal;
